import {Col, Grid, Row} from 'react-bootstrap';
import {Route, BrowserRouter as Router, Switch} from 'react-router-dom';
import Intake from '../Intake/Intake';
import React from 'react';

import './App.css';


function App() {
  return (
    <div>
      <div className='App-Masthead' />
      <Grid>
        <Row>
          <Col className='App-Content' md={8} mdOffset={2}>
            <AppContent />
            <div className='App-Spacer' />
          </Col>
        </Row>
        <Row className='App-Bottom' />
      </Grid>
    </div>
  );
}

function AppContent() {
  return (
    <Router>
      <Switch>
        <Route
          exact
          path='/'
          render={(props) => <Intake config='Index' {...props} />}
        />

        <Route
          exact
          path='/dxa/:token?'
          render={(props) => <Intake config='DXA' {...props} />}
        />

        <Route
          exact
          path='/rmr/:token?'
          render={(props) => <Intake config='RMR' {...props} />}
        />

        <Route
          exact
          path='/vo2/:token?'
          render={(props) => <Intake config='VO2' {...props} />}
        />

        <Route
          exact
          path='/athlete/:token?'
          render={(props) => <Intake config='Athlete' {...props} />}
        />

        <Route
          exact
          path='/thirdparty/:token?'
          render={(props) => <Intake config='ThirdParty' {...props} />}
        />

        <Route
          exact
          path='/done'
          render={(props) => <Intake config='Done' {...props} />}
        />
      </Switch>
    </Router>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js